import * as React from 'react';
import { clsx } from 'clsx';
import * as styles from './CollapsedText.css';
import { ExpandButton } from './components/ExpandButton';
import { useExpandableState } from '../../hooks';
import { DescriptionMarkup } from '../Description';

interface ICollapsedTextProps {
  text?: string;
  lineHeight: number;
  lineCount: number;
  html?: string;
  expandButtonText?: string;
}

export const CollapsedText: React.FC<ICollapsedTextProps> = ({
  text,
  html,
  lineHeight,
  lineCount,
  expandButtonText,
}) => {
  const textRef = React.useRef<HTMLDivElement>(null);
  const [expanded, setExpanded] = React.useState(false);

  const { expandable, maxHeight } = useExpandableState({ textRef, lineCount, lineHeight, expanded });

  const toggleExpanded = React.useCallback(() => {
    setExpanded(!expanded);
  }, [expanded, setExpanded]);

  return (
    <div>
      <div
        data-name="CollapsedTextContent"
        ref={textRef}
        style={{
          maxHeight,
          WebkitLineClamp: lineCount,
          lineHeight: `${lineHeight}px`,
        }}
        className={clsx({ [styles['collapsed']]: !expanded, [styles['expandable']]: expandable })}
      >
        {html ? <DescriptionMarkup html={html} /> : <div className={styles['inline-text']}>{text}</div>}
      </div>
      {expandable && (
        <div className={styles['button']}>
          <ExpandButton expanded={expanded} expandText={expandButtonText} onClick={toggleExpanded} />
        </div>
      )}
    </div>
  );
};
